module.exports = __webpack_public_path__ + "static/media/mediahuis-ireland.395798c9.jpg";